export const MAX_IMAGE_SIZE_MB = 20;
export const MAX_UPLOAD_SIZE_MB = 180;
export const IMAGE_EXTENSIONS = ['bmp', 'gif', 'jpg', 'jpeg', 'png', 'tiff'];
